import { css } from 'styled-components';

export const Vendor = css`
  .aspect-ratio--object {
    z-index: auto;
  }

  /* OneTrust injects this floating cookie button via third-party script */
  #ot-sdk-btn-floating {
    display: none !important;
  }
`;
